






















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import EditableText from "@/modules/plushie/components/EditableText.vue";

import dataStore from "@/store";

import BulkShipmentStore from "../store/index";
import BulkShipmentBox from "../bulk-shipment-box.model";

@Component({
  components: {
    EditableText,
  },
})
export default class BulkShipmentBoxInfo extends Vue {
  @Prop({ required: true })
  public readonly bulkShipmentId!: string;

  @Prop({ default: false })
  public readonly canEdit!: boolean;

  private fIsLoading = false;
  private fBulkShipmentStore: BulkShipmentStore;

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get boxData(): BulkShipmentBox | undefined {
    return this.fBulkShipmentStore.getBulkShipmentBoxById(this.bulkShipmentId);
  }

  constructor() {
    super();

    this.fBulkShipmentStore = getModule(BulkShipmentStore, dataStore);
  }

  public async updateBoxNumber(value?: string): Promise<void> {
    if (!value || !this.boxData) {
      return;
    }

    const boxNumber = parseInt(value, 10);
    if (Number.isNaN(boxNumber)) {
      return;
    }

    await this.updateBox({ boxNumber });
  }

  public async updateBoxLength(value?: string): Promise<void> {
    if (!value || !this.boxData) {
      return;
    }

    const length = parseFloat(value);
    if (Number.isNaN(length) || length <= 0) {
      return;
    }

    await this.updateBox({ length });
  }

  public async updateBoxWidth(value?: string): Promise<void> {
    if (!value || !this.boxData) {
      return;
    }

    const width = parseFloat(value);
    if (Number.isNaN(width) || width <= 0) {
      return;
    }

    await this.updateBox({ width });
  }

  public async updateBoxHeight(value?: string): Promise<void> {
    if (!value || !this.boxData) {
      return;
    }

    const height = parseFloat(value);
    if (Number.isNaN(height) || height <= 0) {
      return;
    }

    await this.updateBox({ height });
  }

  public async updateBoxWeight(value?: string): Promise<void> {
    if (!value || !this.boxData) {
      return;
    }

    const weight = parseFloat(value);
    if (Number.isNaN(weight) || weight <= 0) {
      return;
    }

    await this.updateBox({ weight });
  }

  private async updateBox(updates: Partial<BulkShipmentBox>): Promise<void> {
    if (!this.boxData) {
      return;
    }

    const boxData = this.boxData;

    const updatedBox = new BulkShipmentBox(
      boxData.id,
      updates.boxNumber !== undefined ? updates.boxNumber : boxData.boxNumber,
      updates.length !== undefined ? updates.length : boxData.length,
      updates.width !== undefined ? updates.width : boxData.width,
      updates.height !== undefined ? updates.height : boxData.height,
      updates.weight !== undefined ? updates.weight : boxData.weight
    );

    updatedBox.isNew = false;

    await this.fBulkShipmentStore.saveBulkShipmentBox(updatedBox);
  }

  @Watch("bulkShipmentId", { immediate: true })
  private async loadBoxData(): Promise<void> {
    if (!this.bulkShipmentId) {
      return;
    }

    this.fIsLoading = true;

    try {
      await this.fBulkShipmentStore.loadBulkShipmentBoxById({
        id: this.bulkShipmentId,
      });
    } finally {
      this.fIsLoading = false;
    }
  }
}
